import React from 'react'

import { Loader } from '@fourthwall/components'

import * as S from './InfiniteScrollLoader.styled'

export const InfiniteScrollLoader = () => (
  <S.LoaderWrapper>
    <Loader />
  </S.LoaderWrapper>
)
